// components
import SidebarContainer from "./SidebarContainer";

const Sidebar = () => {
  return <SidebarContainer />;
};

export default Sidebar;
